import { InjectionToken } from '@angular/core';
import { IUser } from '../../../../api/src/lib/models/user/user';
import { BehaviorSubject } from 'rxjs';

export interface UserContext {
  userSubject: BehaviorSubject<IUser>;
}

export const USER_CONTEXT = new InjectionToken<UserContext>('user.context');